import { BonusParametersInput, isBonusParametersInput } from "../../types/BonusParameters";
import { BaseWebComponent } from "../base-components/base-web-component";

/**
 * Questo componente gestisce l'espansione e la contrazione dei parametri bonus nella
 * pagina delle liste dei bonus.
 * Sarà usato in scriptsrc/list-managers/bonus-list-manager.ts come web component.
 * 
 */
export class BonusParametersToggler extends BaseWebComponent {
    static webComponentName = "bonus-parameters-toggler";
    protected _templateId: string = "bonus-parameters-toggler"; // Non usa template
    private toggleButton!: HTMLButtonElement
    public get dataRaw(): string | null {
        return this.attributeStringOption('data-raw', null);
    }
    private _dataRawParsed: any = null;
    public get data(): BonusParametersInput | null {
        if (!this._dataRawParsed && this.dataRaw) {
            try {
                const parsedData = JSON.parse(this.dataRaw);
                if (isBonusParametersInput(parsedData)) {
                    this._dataRawParsed = parsedData;
                }
            }
            catch (error) {
                this._dataRawParsed = null;
            }
        }
        return this._dataRawParsed;
    }
    private _componentId!: string;
    public get componentId(): string {
        if (!this._componentId) {
            this._componentId = this.createRandomId();
        }
        return this._componentId;
    }
protected afterRender(): void {
    this.toggleButton = document.getElementById(`${this.componentId}`) as HTMLButtonElement;
    // Bootstrap dropdown toggle initialization 
    window.bootstrap.Dropdown.getOrCreateInstance(this.toggleButton);
    super.afterRender();    
}
    protected buildRenderingData(): Record<string, any> {
        return {
            hasData: this.data != null,
            count: this.data ? this.data?.length : 0,
            dataRaw: this.dataRaw,
            componentId: this.componentId
        }
    }

}